import { useEffect, useMemo, useState } from 'react';

/** Delay only the copy; each loading period or screen message gets its own timer. */
export function useLoadingText(loading: boolean, context: string) {
  const cycle = useMemo(() => ({ loading, context }), [loading, context]);
  const [visibleFor, setVisibleFor] = useState<typeof cycle | null>(null);

  useEffect(() => {
    if (!cycle.loading) return;
    let cancelled = false;
    const timer = setTimeout(() => {
      if (!cancelled) setVisibleFor(cycle);
    }, 500);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [cycle]);

  return loading && visibleFor === cycle;
}
